var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item,class:_vm.classes,domProps:{"textContent":_vm._s(item)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }